import { render, staticRenderFns } from "./DurumGorunumCellRenderer.vue?vue&type=template&id=b2f902fc"
import script from "./DurumGorunumCellRenderer.vue?vue&type=script&lang=js"
export * from "./DurumGorunumCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./DurumGorunumCellRenderer.vue?vue&type=style&index=0&id=b2f902fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports